import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
interface FooterLink {
  label: string;
  href: string;
}
const LEGAL_LINKS: FooterLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="bg-sand" data-id="element-72" data-mp="36nd1p6jrvpxv">
      <div className="mx-auto max-w-5xl px-5 py-10 sm:py-12" data-id="element-73" data-mp="3ug3etj3ewf9q">
        <div className="flex flex-col gap-7 sm:flex-row sm:items-start sm:justify-between" data-id="element-74" data-mp="38quiv78flpl">
          <div data-id="element-75" data-mp="36czunggsbik">
            <p className="font-display text-[1.25rem] font-extrabold uppercase leading-none tracking-tight text-charcoal sm:text-[1.45rem]" data-id="element-76" data-mp="3lelzi2xtwhm3">
              Postres que <span className="text-gold" data-id="element-77" data-mp="3qblw7n8sg80j">Venden™</span>
            </p>
            <p className="mt-2 font-sans text-[0.8rem] text-taupe" data-id="element-78" data-mp="29y5hc1uw3mvj">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-bold text-gold-deep transition-colors duration-200 ease-out hover:text-charcoal focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-79" data-mp="2ezb99xgq7640">
                Creativo Digital™
              </a>
            </p>
          </div>

          <ul className="space-y-2 text-[0.82rem]" data-id="element-80" data-mp="3qaq0thaztmpz">
            <li data-id="element-81" data-mp="81yv6dh5zo1c">
              <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-82" data-mp="81foxu0vmo35">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-83" data-mp="cvtlhzr9z19e">
                  <MailIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-84" data-mp="qr5g875fkrqb" />
                </span>
                soporte@creativodigital.shop
              </a>
            </li>
            <li data-id="element-85" data-mp="tt0ayvxa0wt4">
              <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-86" data-mp="yu7hysrlhryq">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-87" data-mp="1hkp94sws4fhz">
                  <InstagramIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-88" data-mp="1mk1tn706hahe" />
                </span>
                @creativodigitalstudio
              </a>
            </li>
            <li data-id="element-89" data-mp="3ob5681tmoz4l">
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-90" data-mp="3obok97g5r3dc">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-91" data-mp="21mjyt31ofn54">
                  <GlobeIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-92" data-mp="1wo8q4vn4bioh" />
                </span>
                www.creativodigital.shop
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-stone pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-93" data-mp="2pdfp1vqhiaa9">
          <ul className="flex flex-wrap gap-x-4 gap-y-1.5 font-sans text-[0.74rem] text-taupe/80" data-id="element-94" data-mp="2kbqeeh76bymp">
            {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-95" data-mp="18xuxb2wplfsu">
                <a href={link.href} className="transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-96" data-mp="18yxm95ah1864">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <p className="font-sans text-[0.74rem] text-taupe/80" data-id="element-97" data-mp="2iv1fgmd5fi6w">
            © Creativo Digital™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}